import { Log } from '@apparel/core/log';
import React from 'react';
import { Redirect, Route } from 'react-router';

/**
 *
 * @param url
 * @returns {function(): null}
 */
export const renderRedirect = (url: string) => () => {
    window.location.href = url;
    return null;
};

/**
 * Create a redirect route
 * @param route
 * @param target
 * @param exact
 * @returns {*}
 */
export const redirect = (route: string, target: any, exact = true): any => (
    <Route
        key={`${route}->${typeof target === 'function' ? '[func definition]' : target}`}
        exact={exact}
        path={route}
        render={({ match }) => {
            let target$;
            if (typeof target === 'function') {
                target$ = target({ ...match.params }, match);
            } else {
                target$ = target;
            }

            Log.debug('redirect from "%s" to "%s"', match.url, target$, { ...match.params });

            return <Redirect push={false} to={target$} />;
        }}
    />
);

/**
 * create a redirect from a map
 * @param redirectMap
 * @returns {*[]}
 */
export const redirects = (redirectMap: { [route: string]: string | ((params: any) => string) }): any[] =>
    Object.entries({ ...redirectMap }).map(([route, target]) => redirect(route, target as any));
